import React from "react";
import { useTranslation } from "../../contexts/TranslationContext";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "md",
  message,
}) => {
  const { t } = useTranslation();

  const sizeClasses = {
    sm: "h-6 w-6",
    md: "h-8 w-8",
    lg: "h-12 w-12",
  };

  return (
    <div className="flex flex-col items-center justify-center h-64">
      <div
        className={`animate-spin rounded-full border-b-2 border-primary-500 ${sizeClasses[size]}`}
      ></div>
      {message && (
        <p className="mt-4 text-sm text-gray-500">{message}</p>
      )}
      {!message && (
        <p className="mt-4 text-sm text-gray-500">{t("common.loading")}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;

